import type {FCWithChildren} from 'types';
import {FlexBox} from 'components/layout';

export const MinimalIndentContainer: FCWithChildren = ({children}) => (
  <FlexBox pl={2}>{children}</FlexBox>
);
